import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: `${theme.spacing(1)}px 0`,
    minWidth: "100%",
  },
}));

export { useStyles };